export default "__VITE_ASSET__Tpw_ZSDk__"